import type { Area } from 'core/visitRequestForm/types';
import type { DropdownOption } from 'components/Elements/Dropdown/types';

/**
 * Builds the Site Areas dropdown options. The synthetic "All Areas" option is
 * only offered when the site actually has site areas — on a site with no areas
 * it would let the user make a selection that cannot be persisted, so it is
 * omitted entirely (leaving an empty, unselectable dropdown).
 */
const buildSiteAreaOptions = (siteAreas?: Area[]): DropdownOption[] => {
    if (!siteAreas?.length) {
        return [];
    }

    return [
        { label: 'All Areas', value: 'all' },
        ...siteAreas.map((area) => ({
            label: area.name,
            value: area.id.toString(),
        })),
    ];
};

export default buildSiteAreaOptions;
